import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "text-bold" }
const _hoisted_3 = { key: 0 }

import { BaseFieldEmits } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useViewField, { ViewFieldProps } from 'SharedComponents/Fields/composables/useViewField';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SimpleTextValue' },
  __name: 'SimpleTextValue',
  props: {
    modelValue: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    unit: {}
  },
  emits: ["reveal-history"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emits = __emit;
const { value } = useViewField(props, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _cache[0] || (_cache[0] = _createTextVNode(" :  ")),
    _createElementVNode("span", null, _toDisplayString(_unref(value)), 1),
    (_ctx.unit)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " " + _toDisplayString(_ctx.unit.shortName), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})